import type { RuleNames } from "./feature-names";

/** Italian names of the company rules and rule categories. Same keys as rules.fr.ts. */
export const rulesIt: RuleNames = {
  rules: {
    REFUND_OWNER_APPROVAL_ABOVE_RULE: "Approvazione del proprietario oltre",
    ID_IMAGE_RETENTION_RULE: "Conservazione delle immagini dei documenti",
    FIRST_REPLY_TARGET_RULE: "Tempo per la prima risposta",
    INTERIM_SUSPENSION_REVIEW_RULE: "Revisione di una sospensione provvisoria",
    UNANSWERED_JOB_EXPIRY_RULE: "Scadenza di una richiesta senza risposta",
    SUBSCRIPTION_GRACE_PERIOD_RULE: "Periodo di tolleranza di un abbonamento",
    STAFF_SESSION_INACTIVITY_RULE: "Disconnessione dopo inattività",
  },
  categories: {
    payments: "Pagamenti",
    support: "Pratiche",
    safety: "Fiducia e sicurezza",
    onboarding: "Verifica",
    jobs: "Richieste",
    access: "Accesso",
  },
};
